function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { GiveawayTypes } from 'swag-common/interfaces';
export let GiveawayStep = /*#__PURE__*/function (GiveawayStep) {
  GiveawayStep["naming"] = "naming";
  GiveawayStep["selectProducts"] = "select-products";
  GiveawayStep["productsChoice"] = "products-choice";
  GiveawayStep["reserve"] = "reserve";
  GiveawayStep["customize"] = "customize";
  GiveawayStep["selectLast"] = "select-last";
  GiveawayStep["notecard"] = "notecard";
  GiveawayStep["send"] = "send";
  GiveawayStep["completed"] = "completed";
  GiveawayStep["ended"] = "ended";
  GiveawayStep["suspended"] = "suspended";
  GiveawayStep["budget"] = "budget";
  return GiveawayStep;
}({});
export const GiveawayTypeLabels = {
  [GiveawayTypes.swag]: 'Swag Giveaway',
  [GiveawayTypes.goodie]: 'Goodie Giveaway'
};
export const GiveawayTypeAlternativeLabels = {
  [GiveawayTypes.swag]: 'Gift Giveaway',
  [GiveawayTypes.goodie]: 'Goodie Giveaway'
};
export const GiveawayFileNamesByType = {
  [GiveawayTypes.swag]: 'gift_giveaway',
  [GiveawayTypes.goodie]: 'goodie_giveaway'
};
export const GiveawayStepLabels = {
  [GiveawayStep.naming]: `${GiveawayTypeAlternativeLabels[GiveawayTypes.swag]} name`,
  [GiveawayStep.selectProducts]: 'Update products',
  [GiveawayStep.productsChoice]: 'Choose products',
  [GiveawayStep.reserve]: 'What to offer',
  [GiveawayStep.customize]: 'Landing page',
  [GiveawayStep.selectLast]: 'Landing page',
  [GiveawayStep.notecard]: 'Notecard',
  [GiveawayStep.send]: 'Recipients',
  [GiveawayStep.completed]: 'Completed',
  [GiveawayStep.ended]: 'Ended',
  [GiveawayStep.suspended]: 'Edit cap',
  // Goodie Giveaway
  [GiveawayStep.budget]: 'Budget'
};
export const GoodieGiveawayStepLabels = {
  [GiveawayStep.naming]: `${GiveawayTypeAlternativeLabels[GiveawayTypes.goodie]} Name`,
  [GiveawayStep.budget]: 'Budget',
  [GiveawayStep.customize]: 'Landing page',
  [GiveawayStep.notecard]: 'Notecard',
  [GiveawayStep.send]: 'Recipients',
  [GiveawayStep.completed]: 'Completed'
};
export const GiveawayStepToSaveLabels = {
  [GiveawayStep.naming]: GiveawayStepLabels[GiveawayStep.naming],
  [GiveawayStep.selectProducts]: GiveawayStepLabels[GiveawayStep.selectProducts],
  [GiveawayStep.productsChoice]: GiveawayStepLabels[GiveawayStep.productsChoice],
  [GiveawayStep.reserve]: GiveawayStepLabels[GiveawayStep.reserve],
  [GiveawayStep.customize]: GiveawayStepLabels[GiveawayStep.customize],
  [GiveawayStep.notecard]: GiveawayStepLabels[GiveawayStep.notecard],
  [GiveawayStep.send]: GiveawayStepLabels[GiveawayStep.send],
  [GiveawayStep.suspended]: GiveawayStepLabels[GiveawayStep.suspended]
};
export const GoodieGiveawayStepToSaveLabels = _objectSpread({}, GiveawayStepToSaveLabels, {
  [GiveawayStep.naming]: GoodieGiveawayStepLabels[GiveawayStep.naming],
  [GiveawayStep.budget]: GiveawayStepLabels[GiveawayStep.budget]
});
export const getGiveawayStepsToSaveByType = type => type === GiveawayTypes.goodie ? GoodieGiveawayStepToSaveLabels : GiveawayStepToSaveLabels;
export let GiveawayProductChoice = /*#__PURE__*/function (GiveawayProductChoice) {
  GiveawayProductChoice["all"] = "all";
  GiveawayProductChoice["choice"] = "choice";
  return GiveawayProductChoice;
}({});
export let GiveawaySendTypeTab = /*#__PURE__*/function (GiveawaySendTypeTab) {
  GiveawaySendTypeTab["throughOurPlatform"] = "throughOurPlatform";
  GiveawaySendTypeTab["copyPaste"] = "copyPaste";
  return GiveawaySendTypeTab;
}({});
export let GiveawayCopyLinkTypeTab = /*#__PURE__*/function (GiveawayCopyLinkTypeTab) {
  GiveawayCopyLinkTypeTab["uploadCsv"] = "uploadCsv";
  GiveawayCopyLinkTypeTab["createFewLinks"] = "createFewLinks";
  return GiveawayCopyLinkTypeTab;
}({});
export let GiveawayPreOrderTypeTab = /*#__PURE__*/function (GiveawayPreOrderTypeTab) {
  GiveawayPreOrderTypeTab["quantityAvailable"] = "quantityAvailable";
  GiveawayPreOrderTypeTab["unlimited"] = "unlimited";
  return GiveawayPreOrderTypeTab;
}({});
export let GiveawayLinkStatus = /*#__PURE__*/function (GiveawayLinkStatus) {
  GiveawayLinkStatus["NEW"] = "NEW";
  GiveawayLinkStatus["OPENED"] = "OPENED";
  GiveawayLinkStatus["COMPLETED"] = "COMPLETED";
  GiveawayLinkStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  GiveawayLinkStatus["SHIPMENT_REQUESTED"] = "SHIPMENT_REQUESTED";
  GiveawayLinkStatus["SHIPMENT_REQUESTED_ERROR"] = "SHIPMENT_REQUESTED_ERROR";
  GiveawayLinkStatus["SHIPPED"] = "SHIPPED";
  GiveawayLinkStatus["DELIVERED"] = "DELIVERED";
  GiveawayLinkStatus["CANCELLED"] = "CANCELLED";
  GiveawayLinkStatus["CANCELLED_ON_WAREHOUSE"] = "CANCELLED_ON_WAREHOUSE";
  GiveawayLinkStatus["BACKORDERED"] = "BACKORDERED";
  return GiveawayLinkStatus;
}({});
export const FULFILLED_LINK_STATUSES = [GiveawayLinkStatus.COMPLETED, GiveawayLinkStatus.SHIPMENT_REQUESTED, GiveawayLinkStatus.SHIPMENT_REQUESTED_ERROR, GiveawayLinkStatus.SHIPPED, GiveawayLinkStatus.DELIVERED, GiveawayLinkStatus.BACKORDERED];
export const FULFILLED_AND_CANCELED_LINK_STATUSES = [...FULFILLED_LINK_STATUSES, GiveawayLinkStatus.CANCELLED, GiveawayLinkStatus.CANCELLED_ON_WAREHOUSE];
export let GiveawayLinkCsvSorting = /*#__PURE__*/function (GiveawayLinkCsvSorting) {
  GiveawayLinkCsvSorting["none"] = "none";
  GiveawayLinkCsvSorting["az"] = "az";
  GiveawayLinkCsvSorting["za"] = "za";
  return GiveawayLinkCsvSorting;
}({});
export let GiveawayPaymentSortingOption = /*#__PURE__*/function (GiveawayPaymentSortingOption) {
  GiveawayPaymentSortingOption["old"] = "old";
  GiveawayPaymentSortingOption["new"] = "new";
  GiveawayPaymentSortingOption["high"] = "high";
  GiveawayPaymentSortingOption["low"] = "low";
  return GiveawayPaymentSortingOption;
}({});
export const GiveawayPaymentSortingLabels = {
  [GiveawayPaymentSortingOption.old]: 'Older first',
  [GiveawayPaymentSortingOption.new]: 'Most recent first',
  [GiveawayPaymentSortingOption.high]: 'Higher amount first',
  [GiveawayPaymentSortingOption.low]: 'Lower amount first'
};
export const GiveawayPaymentSortingLabelsKeys = Object.keys(GiveawayPaymentSortingLabels);
export let GiveawayPayFeesPopupFilterOption = /*#__PURE__*/function (GiveawayPayFeesPopupFilterOption) {
  GiveawayPayFeesPopupFilterOption["all"] = "all";
  GiveawayPayFeesPopupFilterOption["canBeFulfilled"] = "canBeFulfilled";
  return GiveawayPayFeesPopupFilterOption;
}({});
export const GiveawayPaymentFilterLabels = {
  [GiveawayPayFeesPopupFilterOption.all]: 'All submissions',
  [GiveawayPayFeesPopupFilterOption.canBeFulfilled]: 'Can be fulfilled'
};
export const GiveawayPaymentFilterLabelsKeys = Object.keys(GiveawayPaymentFilterLabels);
export const SubmittedErrorMessage = 'Sorry, you have already submitted an answer';
export let GiveawayLinkType = /*#__PURE__*/function (GiveawayLinkType) {
  GiveawayLinkType[GiveawayLinkType["single"] = 0] = "single";
  GiveawayLinkType[GiveawayLinkType["uploadCSV"] = 1] = "uploadCSV";
  GiveawayLinkType[GiveawayLinkType["throughPlatform"] = 2] = "throughPlatform";
  return GiveawayLinkType;
}({});
export const nonInventoryUrls = ['/', '/cart', '/collections', '/account/orders', '/custom-store/edit-store', '/account/saved-designs', '/account/profile/settings', '/account/profile/password', '/account/public-api', '/account/public-api/settings'];
export let GiveawayPopups = /*#__PURE__*/function (GiveawayPopups) {
  GiveawayPopups["GIVEAWAY_LINK_PRODUCT_IMAGE_POPUP"] = "GIVEAWAY_LINK_PRODUCT_IMAGE_POPUP";
  return GiveawayPopups;
}({});
export const getDefaultGiveawayDescription = giveawayType => {
  return giveawayType === GiveawayTypes.swag ? "You have been selected to be part of our Gift Giveaway! Select your color and size and fill out where you'd like us to send your item and we will do the rest!" : "You have been selected to receive a Goodie Giveaway! You can use your budget to select from a catalog of delicious items. Just make your choices, tell us where you'd like us to send your package, and we'll do the rest!";
};
export const GIVEAWAY_NAME_MIN_LENGTH = 3;
export const GIVEAWAY_NAME_MAX_LENGTH = 30;
export const isGiveawayNameValid = name => !!name && name.length >= GIVEAWAY_NAME_MIN_LENGTH && name.length <= GIVEAWAY_NAME_MAX_LENGTH;
export const GIVEAWAY_DESCRIPTION_MAX_LENGTH = 2000;
export const isGiveawayDescriptionValid = description => !!description && description.trim().length > 0 && description.length <= GIVEAWAY_DESCRIPTION_MAX_LENGTH;
export const COMPLETED_LINKS_PER_PAGE = 15;
export const GIVEAWAY_CHARGE_LINKS_PER_PAGE = 50;
export let giveawayActivitiesTabType = /*#__PURE__*/function (giveawayActivitiesTabType) {
  giveawayActivitiesTabType["campaigns"] = "campaigns";
  giveawayActivitiesTabType["shipments"] = "shipments";
  return giveawayActivitiesTabType;
}({});
export let giveawayCompletedTabType = /*#__PURE__*/function (giveawayCompletedTabType) {
  giveawayCompletedTabType["completed"] = "completed";
  giveawayCompletedTabType["draft"] = "draft";
  return giveawayCompletedTabType;
}({});
export let completedLinksFilter = /*#__PURE__*/function (completedLinksFilter) {
  completedLinksFilter["all"] = "all";
  completedLinksFilter["needStock"] = "needStock";
  completedLinksFilter["active"] = "active";
  completedLinksFilter["ended"] = "ended";
  return completedLinksFilter;
}({});
export const GIVEAWAY_SHIPMENT_ROWS_PER_PAGE = 10;
export let GiveawayPopupType = /*#__PURE__*/function (GiveawayPopupType) {
  GiveawayPopupType["payFees"] = "payFees";
  GiveawayPopupType["history"] = "history";
  GiveawayPopupType["completed"] = "completed";
  return GiveawayPopupType;
}({});
const commonStatuses = [GiveawayLinkStatus.COMPLETED, GiveawayLinkStatus.SHIPPED, GiveawayLinkStatus.SHIPMENT_REQUESTED, GiveawayLinkStatus.SHIPMENT_REQUESTED_ERROR, GiveawayLinkStatus.DELIVERED, GiveawayLinkStatus.CANCELLED];
export const linksByPopup = {
  [GiveawayPopupType.completed]: [GiveawayLinkStatus.PENDING_APPROVAL, ...commonStatuses],
  [GiveawayPopupType.payFees]: [GiveawayLinkStatus.COMPLETED],
  [GiveawayPopupType.history]: [...commonStatuses]
};
export const GIVEAWAY_FEEDBACK_LIMIT = 500;
export const OUT_OF_STOCK_DEBOUNCE_TIMEOUT = 200;
export const GIVEAWAY_LANDING_FALLBACK_COLOR = '#00bfff';